import React, { Suspense, lazy } from "react"
import { Router, Switch, Route } from "react-router-dom"
import { history } from "./history"
import { connect } from "react-redux"
import { Redirect } from "react-router-dom"
import Spinner from "./components/@vuexy/spinner/Loading-spinner"


import { ContextLayout } from "./utility/context/Layout"
import Authorize from "./views/pages/authentication/Authorize"
import config from "./config"

// Route-based code splitting
const analyticsDashboard = lazy(() =>
  import("./views/dashboard/analytics/AnalyticsDashboard")
)
const studentDashboard = lazy(() =>
  import("./views/dashboard/analytics/Dashboard")
)
const accountSettings = lazy(() =>
  import("./views/pages/account-settings/AccountSettings")
)
const profile = lazy(() => import("./views/pages/profile/Profile"))


////////////////////////School Room Help/////////////////////

///////////////////Manage Students/////////////////
const StudentList = lazy(() =>
  import("./views/pages/studentsList/studentList")
)

const StudentProfile = lazy(() =>
  import("./views/pages/StudentsProfile/StudentProfile")
)

const FindTutor = lazy(() =>
  import("./views/pages/find-tutor/find-tutor")
)

////////////////////MAnage School////////////////
const manageSchool = lazy(() => import("./views/pages/school/Profile"))

const manageCredits = lazy(() => import("./views/pages/manage-credits/ManageCredit"))
const manageCreditsHistory = lazy(() => import("./views/pages/manage-credits/creditHistory"))


///////////////Manage Classes//////////////


const classList = lazy(() => import("./views/pages/classes/classList"))

const approvalClassList = lazy(() => import("./views/pages/approval-classes/classList"))

const completedClasses = lazy(() => import("./views/pages/completed-classes/completed-classes"))

const ongoingClasses = lazy(() => import("./views/pages/ongoing-classes/ongoing-classes"))

const viewClass = lazy(() => import("./views/pages/view-class/Profile"))

/////////Manage Topics///////////


const feeds = lazy(() => import("./views/pages/feeds/feeds"))

const classTopics = lazy(() => import("./views/pages/current-class-topics/current-class-topics"))


const topicList = lazy(() => import("./views/pages/topics/topic-list"))
const myTopicAnswerList = lazy(() => import("./views/pages/my-topic-answers/my-topic-answers"))
const myFavoriteTopicList = lazy(() => import("./views/pages/my-favorite-topics/my-favorite-topics"))

const topicView = lazy(() => import("./views/pages/view-topic/Profile"))

//////////Notifications//////////////////

const Notifications = lazy(() => import("./views/pages/notifications/notifications"))


///////////////Calendar/////////////////////
const calendar = lazy(() => import("./views/pages/calendar/Calendar"))

const Appointment = lazy(() => import("./views/pages/calendar/AppointmentForm"))

const ViewAppointment = lazy(() => import("./views/pages/calendar/ViewAppointment"))
const ViewAppointmentMeeting = lazy(() => import("./views/pages/calendar/AppointmentMeeting"))

const MyAppointment = lazy(() => import("./views/pages/appointments/appointment-list"))

const BookAppointment = lazy(() => import("./views/pages/calendar/BookAppointment"))

const TutorSlots = lazy(() => import("./views/pages/find-tutor/week-tutor-slots"))

const Auth = {
  isAuthenticated: localStorage.getItem('user') ? true: false
};
// Set Layout and Component Using App Route
const RouteConfig = ({ component: Component, fullLayout, ...rest }) => (
  <Route
    {...rest}
    render={props => {
      return (
        Auth.isAuthenticated ? (
        <ContextLayout.Consumer>
          {context => {
            let LayoutTag =
              fullLayout === true
                ? context.fullLayout
                : context.state.activeLayout === "horizontal"
                ? context.horizontalLayout
                : context.VerticalLayout
            return (
              <LayoutTag {...props} permission={props.user}>
                <Suspense fallback={<Spinner />}>
                  <Component {...props} />
                </Suspense>
              </LayoutTag>
            )
          }}
        </ContextLayout.Consumer>) : (
          <Redirect
            to={{
              pathname: "/authorize",
              state: { from: props.location }
            }}
          />
        )
      )
    }}
  />
)
const mapStateToProps = state => {
  return {
    user: state.auth.login.userRole
  }
}

const AppRoute = connect(mapStateToProps)(RouteConfig)

class AppRouter extends React.Component {

  render() {
    return (
      // Set the directory path if you are deploying in sub-folder
      <Router history={history}>
        <Switch>
          <AppRoute exact path="/pages/profile" component={profile} />
          <AppRoute exact
            path="/account-settings"
            component={accountSettings}
          />
          <AppRoute exact path="/" component={analyticsDashboard} />

          <AppRoute exact path="/feeds" component={feeds} />
          
          <AppRoute exact path="/student-dashboard" component={studentDashboard} />
          
          <Route exact path="/authorize" component={Authorize} />
          
          ///////////////Manage Profile////////////////
          /////////////////Manage School///////////////////////
          
          <AppRoute exact path="/school-profile" component={manageSchool} />


          <AppRoute exact path="/wallet" component={manageCreditsHistory} />
          <AppRoute exact path="/credits-top-up" component={manageCredits} />
          /////////////////Manage Classes/////////////////

          
          <AppRoute exact path="/manage-classes" component={classList} />
          <AppRoute exact path="/manage-classes/approval-classes" component={approvalClassList} />
          <AppRoute exact path="/manage-classes/completed-classes" component={completedClasses} />
          <AppRoute exact path="/manage-classes/current-classes" component={ongoingClasses} />
          <AppRoute exact path="/manage-classes/list-of-classes/class-detail/:id" component={viewClass} />


          /////////Manage Topics /////////////////
          <AppRoute exact path="/manage-topics" component={topicList} />
          <AppRoute exact path="/my-topic-answers" component={myTopicAnswerList} />
          <AppRoute exact path="/my-favorite-topics" component={myFavoriteTopicList} />

          <AppRoute exact path="/manage-topics/list-of-topics/view-topic/:id?/:flag?" component={topicView} />
          <AppRoute exact path="/class-topics" component={classTopics} />

          //////////////////Notifications/////////////

          <AppRoute exact path="/notifications" component={Notifications} />

          ///////////////Manage Students////////////
          <AppRoute exact path="/manage-students" component = {StudentList} />

          <AppRoute exact path="/manage-students/list-of-students/profile/:id" component = {StudentProfile} />


          <AppRoute exact path="/calendar" component = { calendar } />

          <AppRoute exact path="/appointment" component = { Appointment } />
          <AppRoute exact path="/book-appointment" component = { BookAppointment } />
          <AppRoute exact path="/view-appointment" component = { ViewAppointment } />
          <AppRoute exact path="/view-appointment-meeting/:id" component = { ViewAppointmentMeeting } />

          <AppRoute path="/my-appointments" component={MyAppointment}/>
          <AppRoute path="/tutor-slots" component={TutorSlots} />

          <AppRoute path="/find-tutor" component={FindTutor}/>



        </Switch>
      </Router>
    )
  }
}

export default AppRouter
